import { render, staticRenderFns } from "./OrganizationalChart.vue?vue&type=template&id=10c037f6&scoped=true"
import script from "./OrganizationalChart.vue?vue&type=script&lang=js"
export * from "./OrganizationalChart.vue?vue&type=script&lang=js"
import style0 from "./OrganizationalChart.vue?vue&type=style&index=0&id=10c037f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c037f6",
  null
  
)

export default component.exports